import type { CommentsItemPeopleItemT } from '@root/src/types';
import { observer } from 'mobx-react';
import type { FC } from 'react';
import { lazy, Suspense } from 'react';

const Component = lazy(async () => await import('./component'));

export interface PeopleReviewsModalProps {
  peopleItem: CommentsItemPeopleItemT;
  onCloseModal: () => void;
}

const PeopleReviewsModal: FC<PeopleReviewsModalProps> = props => (
  <Suspense fallback={null}>
    <Component {...props} />
  </Suspense>
);

export default observer(PeopleReviewsModal);
